import api from '@/services/api'

export default () => new Promise((resolve,reject) => api()({
    url : '/webshop/user/'
}).then(e => resolve(e)).catch(err => reject(err)) )  